import { render } from "./ImporterIndex.vue?vue&type=template&id=5b432255"
import script from "./ImporterIndex.vue?vue&type=script&lang=js"
export * from "./ImporterIndex.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PHPStormProjects\\hqam-customer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__